import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextComponent } from './text.component';

@NgModule({
  exports: [TextComponent],
  imports: [CommonModule, TextComponent],
})
export class TextModule {}
